import {
  saveLocalStorage,
  getToken,
  getLocalStorage
} from "components/Helper/Helper";
import { Config } from "../../../Config.js";
import axios from "axios";
import { toast } from "react-toastify";
import { LOADER_STATUS, COMPANIES_DATA, TOTAL_RECORD,GET_ALL_GROUPS, REGION_LIST, DEPARTMENT_LIST } from "./constants";
export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status
  };
}
export function companies(data) {
  return {
    type: COMPANIES_DATA,
    payload: data
  };
}
export function departmentList(data) {
  return {
    type: DEPARTMENT_LIST,
    payload: data
  };
}
export function regionList(data) {
  return {
    type: REGION_LIST,
    payload: data
  };
}

export function totalRecord(val, recordVal) {
  return {
    type: TOTAL_RECORD,
    totalRecords: val,
    records: recordVal
  };
}

export function setAllGroups(data) {
  return {
    type: GET_ALL_GROUPS,
    payload: data
  };
}

/* Update Company details */
export const updateCompany = (bodyFormData) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/addPartner_master`,
        headers: {
          token: getLocalStorage("loginDetails"),
          "Content-Type": "application/json"
        },
        data: bodyFormData
      })
        .then((response) => {
          dispatch(loader(false));
          if (response.data.error != 1) {
            toast.success(response.data.message, {
              position: "bottom-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });
            resolve(true);
          } else {
            toast.error(`Error: ${response.data.data}`, {
              position: "bottom-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });

            reject(true);
          }
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
};
export function getPartner(search, page,recordLimit=10) {
  let data = {
    searchText: '',
    currentPage:1,
    fromDate:null,
    toDate:null,
    recordLimit: 10000000
  };
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getPartner_master`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((response) => {
          dispatch(loader(false));
          
          resolve(response.data.data);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
}
export function getDepartmentList() {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${Config.url}console/getDepartment`,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((response) => {
          dispatch(loader(false));
          dispatch(departmentList(response.data.data));
          resolve(response.data.data);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
}
export function getRegionList() {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${Config.url}console/getRegion_master`,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((response) => {
          dispatch(loader(false));
          dispatch(regionList(response.data.data));
          resolve(response.data.data);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
}
export function getAllPartner(search, page,fromDate,toDate,rowPerPageLimit=10,isDownload=false,status=null) {
  let data = {
    searchText: search||'',
    currentPage: page||1,
    fromDate:fromDate||null,
    toDate:toDate||null,
    recordLimit: rowPerPageLimit||10,
    isDownload:isDownload,
    status:[0,1].includes(status)?status:null
  };
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getPartner_master`,
        responseType:isDownload?"blob":undefined,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((response) => {
          dispatch(loader(false));
          if(isDownload){
            const url = window.URL.createObjectURL(new Blob([response.data]));
            // Create a link element to trigger the download
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Partner.xlsx");
            // Append the link to the document body and trigger the download
            document.body.appendChild(link);
            link.click();
            resolve(true);
          }else{
            const modifiedData = response.data.data.map((item) => {
              let returnItem = { ...item };
              if (returnItem.created_date != null) {
                returnItem.created_date = new Date(item.created_date);
                return returnItem;
              }
              return item;
            });
            console.log("responceData", modifiedData);
            if(modifiedData&&modifiedData.length>0&&modifiedData[0].total){
              dispatch(
                totalRecord(Math.ceil(modifiedData[0].total /rowPerPageLimit),
                modifiedData[0].total
                )
              );
            }
            else{
              dispatch(
                totalRecord(1,0)
              );
            }
            dispatch(companies(modifiedData));
          }

          
          
          
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
}
export function deactivateCompany(data) {
  console.log("ID we got in actions is" + JSON.stringify(data));
  let status = data.active == "Active" ? 0 : 1;
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/togglePartner`,
        headers: {
          token: getLocalStorage("loginDetails")
        },
        data: {
          id: data.id,
          active: status
        }
      })
        .then((response) => {
          let msg =
            status == 1
              ? "Entity Deactivated Successfully"
              : "Entity Activated Successfully";
          toast.success(msg, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
          resolve(true);
        })
        .catch((error) => {
          toast.error(`Operation Failed`, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
          window.alert(error);
          reject(true);
        });
    });
  };
}

export const getAllGroupList = () => {
  let data = {
    currentPage: 1,
    recordLimit: 1000000
  };
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getGroup`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((res) => {
          if (res.data.error == 0) {
            dispatch(loader(false));
            console.log("group list",res.data)
            let formatted_response = res.data.data?.map((element) => {
              return {
                id: element.id,
                name: element.group_name
              };
            });
            dispatch(setAllGroups(formatted_response));
            resolve(true);
          }
        })

        .catch((e) => {
          console.log(e);
          dispatch(loader(false));
          window.alert(e);
          reject(true);
        });
    });
  };
};

function formatDate(date) {
  // converting yyyy-mm-dd to DD MM YYYY format
  // let monthArr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sept','Oct','Nov','Dec'];
  let splittedDate = date.split("-");
  let day = splittedDate[2];
  let mon = splittedDate[1];
  // if(mon < 10){
  //   mon = '0' + mon
  // }
  let yr = splittedDate[0];

  return day + "/" + mon + "/" + yr;
}

function tConvert(time) {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    // time[5] = +time[0] < 12 ? 'AM' : ' PM'; // Set AM/PM
    // time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
}
